





































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import { userProfiles } from '@/api/const'
import { UserData } from '@/generated/model/userData'

@Component({
  computed: {
    ...mapGetters('user', [ 'invalidCredentials', 'preSelectedUserProfile', 'allUserProfiles'])
  }
})
export default class LoginDialog extends Vue {
  @Prop() private value: boolean = false

  private password = ''
  private invalidCredentials!: boolean
  private allUserProfiles!: UserData[]
  private userProfilesList = userProfiles
  private selectedUser = 'basic'
  private preSelectedUserProfile!: string
  private showPassword: boolean = false
  private renderPasswordField: boolean = false

  private rules: object = {
    required: (v: any) => !!v || (!this.isValidCredentials() ? this.localText('login.wrongUserNameOrPassword') : this.localText('general.required'))
  }

  isValidCredentials() {
    return !this.invalidCredentials
  }

  disabledPassword(): boolean {
    return this.allUserProfiles.filter(p => !p.loginRequired).map(p => p.userName).includes(this.selectedUser)
  }

  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.renderPasswordField = true
      }, 100)
    })
  }

  private resolve: any = () => { return false }

  private localText (arg: string): string {
    return String(this.$t(arg))
  }

  private getPreSelectedUserProfile(): string {
    return  this.preSelectedUserProfile
  }

  private cancel () {
    this.$store.commit('user/setInvalidCredentials', false)
    this.$emit('cancel')
    this.resolve(true)
  }

  private async login () {
    const credentials = {
      userName: this.selectedUser,
      password: this.password
    }
    await this.$store.dispatch('user/userLogin', credentials)
    this.$emit('login')
    if (this.invalidCredentials) {
      this.password = ''
      this.resolve(false)
    } else {
      this.resolve(true)
    }
  }

  @Watch ('selectedUser')
  private selectedUserWatcher (value: boolean) {
    this.$store.commit('user/setInvalidCredentials', false)
    this.disabledPassword()
  }

  @Watch ('preSelectedUserProfile')
  private preSelectedUserWatcher (value: string) {
    this.selectedUser = value
  }

  @Watch ('value')
  private valueWatcher (value: boolean) {
    if (!value) {
      this.password = ''
    }
  }
}

